import { Button } from '@playbooks/ui/components/button';

import { AuthBrand } from 'components/auth/auth-brand';
import { AuthFormShell } from 'components/auth/auth-form-shell';
import { AuthProviderActions } from 'components/auth/auth-provider-actions';

const AuthOptions = ({ onAuth, onView }) => {
	// Render
	return (
		<AuthFormShell as='section' className='space-y-5'>
			<AuthBrand title='Welcome to Playbooks' description='Build with agents that do the work' />
			<div className='flex-column gap-2'>
				<AuthProviderActions onNext={onAuth} />
				<Button
					type='button'
					variant='outline'
					size='lg'
					prevIcon='envelope'
					onClick={() => onView('login')}
					className='w-full'>
					Continue with email
				</Button>
			</div>
		</AuthFormShell>
	);
};

export { AuthOptions };
